import { REQUEST_URL } from "../constants";
import { LanguageInputModel } from "../models";
import { RequestUtil } from "../utils";

export const LanguageService = {
  getLanguages,
  createLanguage,
};

function getLanguages() {
  const url = REQUEST_URL.GET_ALL_LANGUAGE;

  return RequestUtil.get({ url });
}

function createLanguage(data: LanguageInputModel) {
  const url = REQUEST_URL.CREATE_LANGUAGE;

  return RequestUtil.post({ url, data });
}